import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CloudUploadIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.01397 15.9858C6.02665 15.9869 5.07363 15.6236 4.3375 14.9657C3.60138 14.3077 3.1339 13.4013 3.02464 12.42C2.91537 11.4387 3.17201 10.4517 3.74537 9.64788C4.31873 8.8441 5.1685 8.28013 6.13188 8.06402C5.85314 6.76403 6.10224 5.40656 6.82437 4.29023C7.5465 3.17391 8.68251 2.39017 9.9825 2.11143C11.2825 1.83269 12.64 2.08178 13.7563 2.80391C14.8726 3.52604 15.6563 4.66206 15.9351 5.96204H16.0353C17.2782 5.96079 18.4772 6.42141 19.3996 7.25447C20.322 8.08754 20.9019 9.23362 21.0268 10.4702C21.1518 11.7068 20.8127 12.9457 20.0756 13.9464C19.3384 14.9471 18.2557 15.6382 17.0377 15.8855M15.0329 12.9786L12.0258 9.97153M12.0258 9.97153L9.01871 12.9786M12.0258 9.97153V22"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

CloudUploadIcon.displayName = 'CloudUploadIcon';
